import http from '../http'

export default {
  // 忘记密码
  passwordReset(data: object, option: object = {}) {
    return http.post('/crm/pf_user/password/reset', data, option)
  },
}
